import api from '@/apis'

// export const fetchSessions = params => api.get(`/orders`, {
//   params
// })
export const getOrderList = params => api.get(`/orders`, { params })

export const getOrder = id => api.get(`/orders/${id}`)

export const addMemo = ({
  id,
  memo
}) => api.post(`/orders/${id}/add_memo`, {
  memo
})

export const closeOrder = ({
  id,
  params
}) => api.post(`/orders/${id}/close`, params)
export const closeOrder2 = ({
  id,
  params
}) => api.post(`/order/${id}/cancel`, params)
export const refuseCloseOrder = ({
  id,
  params
}) => api.post(`/orders/${id}/refuse_close`, params)

export const tenantCloseOrder = ({
  id,
  params
}) => api.post(`/orders/${id}/tenant_close`, params)


export const createOrder = data => api.post(`/orders2`, data)

export const editOrder = (id, data) => api.put(`/orders2/${id}`, data)

export const receiveOrder = (id, data) => api.post(`/orders/${id}/receive`, data)

export const assignOrder = (id, data) => api.put(`/orders/${id}/assign`, data)

export const updateWorkerFee = (id, worker_fee) => api.put(`/orders/${id}/change_worker_fee`, {
  worker_fee
})

export const updateWorkerServiceFee = (id, worker_fee) => api.put(`/orders/${id}/change_worker_service_fee`, {
  worker_fee
})

export const updatePrice = (id, fee) => api.put(`/orders/${id}/change_fee`, {
  fee
})

export const lockFee = id => api.post(`/orders/${id}/lock_fee`)

// export const setWaitExpressStatus = (id, unset) => api.put(`/orders/${id}/set_wait_express`, { unset })

export const setCompleteState = id => api.post(`/orders/${id}/confirm_complete`)

export const setWorkerComplete = id => api.post(`/orders/${id}/complete`)

// export const setServiceFaildState = id => api.post(`/orders/${id}/set_service_faild`)
export const toggleTag = (id, tag) => api.post(`/orders/${id}/toggle_tag`, { tag })

export const updateServiceTime = (id, service_time) => api.put(`/orders/${id}/change_service_time`, {
  service_time
})

export const assignWorker = (id, worker) => api.put(`/orders/${id}/assign_worker`, {
  worker
})
export const assignWbjWorker = data => api.post(`/order/assign/wbjWorker`, data)

export const confirmLocation = (id, data) => api.post(`/orders/${id}/confirm_location`, data)

export const appealOrder = (id, data) => api.post(`/orders/${id}/appeal_order`, data)

export const fetchOrderEvent = (id) => api.get(`/orders/${id}/events`)

export const remindWorkerService = (id, data) => api.get(`/orders/${id}/remind_worker_service`, { params: data })
export const tenantRemindWorkerService = (id, data) => api.get(`/order/remind/order/${id}`, { params: data })

export const setAcceptStatus = (id, data) => api.put(`/orders/${id}/set_accept_status`, data)

export const sendWorkerToUser = (id) => api.put(`/orders/${id}/send_worker_to_user`)

export const saveOrderExpress = (id, data) => api.post(`/express/${id}/saveOrderExpress`, data)

export const addExpress = (id, data) => api.post(`/express/${id}/addExpress`, data)

export const queryExpress = params => api.get(`/express/queryExpress`, { params })

export const saveOrderAccessory = data => api.post(`/accessory/save`, data)

export const deleteOrderAccessory = id => api.delete(`/accessory/${id}/remove`)

export const findMemoAll = (data) => api.get(`/findMemoAll`, { params: data })

export const setTaskTag = (data) => api.get(`/task/tag`, { params: data })

export const addMemo2 = data => api.post(`/addMemo2`, data)

export const getGuaqiSelect = (data) => api.get(`/order/guaqi/select`, { params: data })
export const setEvaluate = (data) => api.post(`/order/${data.orderId}/evaluate`, data)
export const getEvaluateInfo = (data) => api.get(`/order/${data.orderId}/evaluate/info`, { params: data })
export const getEvaluateWait = (data) => api.get(`/order/${data.orderId}/evaluate/wait`, { params: data })
export const orderGuaqi = data => api.post(`/order/${data.orderId}/guaqi`, data)
export const getBaojiaList = (data) => api.get(`/order/${data.orderId}/baojiaList`, { params: data })
export const getManagersCustom = (data) => api.get(`/managers/custom`, { params: data })
export const getTenantsStaff = (data) => api.get(`/tenants/mystaff/list`, { params: data })
export const updateOrderPubOne = (id, fee) => api.post(`/order/pub/one/${id}`, { fee: fee })
export const orderClaim = (data) => api.post(`/tenants/order/claim`, data)
export const orderWaitOp = (data) => api.get(`/order/info/waitOp/${data.orderId}`, { params: data })
export const saveApplyFeeCheck = (data) => api.post(`/order/${data.applyFeeId}/applyFeeCheck`, data)
export const saveClaimCheck = (data) => api.post(`/manager/order/claim/check`, data)
export const saveEvaluateCheck = (data) => api.post(`/order/${data.id}/evaluate/check`, data)
export const managerArbitrationCheck = (data) => api.post(`/manager/arbitration/check`, data)